import * as React from "react";
// import { pure } from 'recompose'
import * as StyledComponent from "@tunnel-components/@sharded/@styled/styled";
import * as i18next from "i18next";
/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const { isOpen, toggleModal } = props;

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */
  return (
    <StyledComponent.ModalContainer isVisible={isOpen} onClick={toggleModal}>
      <StyledComponent.ModalContainerInsider
        isVisible={isOpen}
        style={{
          overflow: "visible",
          width: "660px",
          backgroundColor: "unset",
        }}
      >
        <div className="title-sequence-infos">
          {i18next.t("attention")}
          <span onClick={toggleModal} />
        </div>
        <div className="sequence-content">
          <p> {i18next.t("etes-vous sur de vouloir suprimer ce masque")}</p>
          <p> {i18next.t("toute suppression sera definitive")}</p>
        </div>
        <div className="modalBtn">
          <span className="btnSecondary">Ok {i18next.t("ok")}</span>
          <span className="btnSecondary" onClick={toggleModal}>
            {i18next.t("non")}
          </span>
        </div>
      </StyledComponent.ModalContainerInsider>
    </StyledComponent.ModalContainer>
  );
};
/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  isOpen?: any;
  toggleModal?: any;
}
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/widgets/modal/warning/component.tsx